<template>
  <b-input-group>
    <b-form-select v-bind="$attrs"
                   :size="small ? 'sm' : null"
                   :class="{ 'pl-1': small }"
                   :value="value"
                   :value-field="valueField"
                   :text-field="textField"
                   @input="onInput"
                   @change="onChange">
      <option v-if="placeholder" :value="null" selected disabled hidden>{{ placeholder }}</option>
    </b-form-select>
    <b-input-group-append>
      <b-btn :size="small ? 'sm' : null"
             :variant="value !== undefined && value !== null ? 'primary' : 'outline-secondary'"
             :disabled="value === undefined || value === null"
             @click="clearValue">
        <font-awesome-icon icon="times" />
      </b-btn>
    </b-input-group-append>
  </b-input-group>
</template>

<script>

export default {
  name: "SearchSelect",

  props: {
    value: {
      default: null
    },

    valueField: {
      type: String,
      default: 'value'
    },

    textField: {
      type: String,
      default: 'text'
    },

    small: {
      type: Boolean,
      default: false
    },

    placeholder: {
      type: String
    }
  },

  methods: {
    // Fire input event
    onInput(value) {
      this.$emit('input', value);
    },

    // Fire change event only when control has focus, e.g. enter is pressed
    onChange(value) {
      // Emit input first because regular input event is triggered after change event
      this.$emit('input', value);
      this.$emit('change', value);
    },

    // Clears the current value
    clearValue() {
      this.$emit('input', null);
      this.$emit('change', null);
    }
  }
}
</script>

<style>
</style>
